export class EventTypes {

  static infrastructure ='front_infrastructure';
  static systemManagement ='front_systemManagement';
  static sendingSystem ='front_sendingSystem';
  static smsReport ='front_smsReport';
  static financial ='front_financial';
  static facility ='front_facility';
  static setting ='front_setting';
  static services ='front_services';
  static dashboard ='front_dashboard';
  static whiteMessages ='front_whiteMessages';
  static statisticalReports ='front_statisticalReports';
  static smsPackage ='front_smsPackage';
  static privateNumberPrice ='front_privateNumberPrice';
  static requests ='front_requests';
  static voiceMessages ='front_voiceMessages';
  static medias ='front_medias';
  static contentManagement ='front_contentManagement';
  static packageOrganization ='front_packageOrganization';
  static privateNumberBuy ='front_privateNumberBuy';
  static statisticalReportsUsers ='front_statisticalReportsUsers';
  static statisticalReportsAdmin ='front_statisticalReportsAdmin';
  static baseFormPage ='front_baseFormPage';
  static baseIndexPage ='front_baseIndexPage';
  static account ='front_account';
  static plans ='front_plans';
  static buyPlans ='front_buyPlans';
  static smartSms ='front_smartSms';
  static filimoSmart ='front_filimoSmart';

}
